<template>
    <div class="container nopadding">
        <div class="wrapper">
            <div class="header"><h1>{{$t('layout_carrello_tooltip')}}</h1></div>
            <!-- prodotto -->
            <div v-if="this.order.items.length">
                <div class="content-carrello">
                    <inc-cart-products/>
                    <div class="consegna" v-if="['DELIVERY', 'DIL'].includes(this.order.type)">
                        <div class="text-center desc">{{$t('carrello_avviso_spese_consegna')}}</div>
                    </div>
                    <div class="subtotale gray">
                        <i>{{$t('carrello_tempo_disponibile')}}</i>
                        <div class="tot">{{$t('totale')}}
                            {{this.order_total_products_price.toFixedGood(2)}} {{locale_currency}}
                        </div>
                    </div>
                    <div class="totale bg-black">
                        <button class="btn btn-default pull-left" type="button" @click="reset()">
                            {{$t('carrello_ord_del')}}
                        </button>
                        <button type="button" class="btn btn-primary float-right" @click="submit()"
                                :disabled="this.loading_visible">
                            {{$t('prosegui')}}
                        </button>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            <div class="content-carrello text-center" style="padding: 30px" v-else>
                <h1>{{$t('carrello_vuoto')}}</h1>
            </div>
        </div>

        <inc-suggested-products v-if="this.order_suggested_products.length"
                                :suggested-products="this.order_suggested_products"
                                :blacklisted-products="this.order_products_ids"/>
    </div>
</template>

<script>
import moment from 'moment';
import {mapState, mapGetters, mapActions} from 'vuex';
import {addToBlockingList, cartCheck} from '../../api/account';
import {getTimezone} from '../../libraries/utils';

import IncSuggestedProducts from '../partials/IncSuggestedProducts';
import ModalErrors from '../partials/ModalErrors';
import IncCartProducts from './partials/IncCartProducts';

export default {
    name: "Cart",
    components: {IncCartProducts, ModalErrors, IncSuggestedProducts},
    created() {
        if (this.loading_visible) {
            this.showLoading(false);
        }
    },
    computed: {
        ...mapState('global', {
            loading_visible: 'loading_visible'
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapGetters('restaurant', {
            locale_currency: 'localeCurrency'
        }),
        ...mapGetters('order', {
            order_total_products_price: 'totalProductsPrice',
            order_products_ids: 'productsIds',
            order_suggested_products: 'suggestedProducts'
        }),
        ...mapGetters('auth', {
            user_authenticated: 'authenticated'
        })
    },
    methods: {
        reset: function () {
            this.resetOrder();
            this.$router.push({name: 'orders'});
        },
        submit: function () {
            if (!this.user_authenticated) {
                this.$router.push({name: 'user.login', query: {back: 'cart'}});
            } else {
                if (['MANGIA_RISTORANTE', 'ORDINA_TAVOLO'].includes(this.order.type)) {
                    this.$router.push({name: 'cart.summary'});
                } else {
                    this.showLoading(true);
                    cartCheck(this.language, {
                        id_ristorante: this.id_ristorante,
                        email: this.user.email,
                        api_key: this.user.api_key,
                        data: moment(this.order.date).format("YYYY-MM-DD HH:mm:ss"),
                        id_orario: this.order.id_orario,
                        timezone: getTimezone(),
                        ordine_tipo: this.order.type.toLowerCase(),
                        ordine_totale: this.order_total_products_price,
                        id_locale: this.locale.id,
                        ordine_indirizzo: this.order.address,
                        id_punto_di_servizio: this.order
                            .id_punto_di_servizio
                    }).then(() => {
                        addToBlockingList(this.language, {
                            id_ristorante: this.id_ristorante,
                            email: this.user.email,
                            api_key: this.user.api_key,
                            data: moment(this.order.date).format("YYYY-MM-DD HH:mm:ss"),
                            id_orario: this.order.id_orario,
                            timezone: getTimezone()
                        }).then((response) => {
                            this.setOrderTimeLimit({
                                limit: response.limite_tempo
                            });

                            this.$router.push({name: 'cart.summary'});
                        }).catch(({messages}) => {
                            this.showModalCartExpired({
                                show: true,
                                error: messages.length ? messages[0] : ''
                            });
                        }).finally(() => {
                            this.showLoading(false);
                        });
                    }).catch(({messages}) => {
                        this.showModalErrors({
                            title: this.$t('attenzione_label').toUpperCase(),
                            errors: messages
                        });
                        this.showLoading(false);
                    });
                }
            }
        },
        ...mapActions('order', {
            resetOrder: 'reset',
            setOrderTimeLimit: 'setTimeLimit'
        }),
        ...mapActions('global', [
            'showLoading',
            'showModalCartExpired',
            'showModalErrors'
        ])
    }
}
</script>
